import React, { useEffect, useState } from 'react';
import axios from '../api/axiosConfig';

/**
 * Modal para registrar un intento de ejecución (matrícula) no exitoso.
 * Si el motivo genera novedad, el trámite pasa a Novedades; si no, sale de "Listos para Finalizar"
 * hasta que se habilite el reintento.
 */
const NoEjecutadoModal = ({ isOpen, tramite, onClose, onSuccess }) => {
  const [motivos, setMotivos] = useState([]);
  const [motivo, setMotivo] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setMotivo('');
    setObservaciones('');
    axios.get('/api/tramites/motivos-no-ejecucion')
      .then(r => setMotivos(r.data || []))
      .catch(() => setMotivos([]));
  }, [isOpen]);

  if (!isOpen || !tramite) return null;

  const selected = motivos.find(m => m.key === motivo);
  const plate = tramite.datos_adicionales?.placa_referencia || tramite.plate_number || 'N/A';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!motivo) return alert('Seleccione el motivo');
    if (motivo === 'otro' && !observaciones.trim()) return alert('Describa el motivo en observaciones');
    try {
      setSaving(true);
      const res = await axios.post(`/api/tramites/${tramite.id}/no-ejecutado`, { motivo, observaciones });
      alert('✅ ' + (res.data?.message || 'Intento registrado'));
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.message || 'Error al registrar el intento'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '520px', width: '95%' }}
        role="dialog" aria-modal="true" aria-labelledby="no-ejecutado-title">
        <form onSubmit={handleSubmit}>
          <div className="modal-header" style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
            <h3 id="no-ejecutado-title" style={{ margin: 0, color: '#b45309' }}>⛔ Intento de ejecución no exitoso</h3>
            <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#64748b' }}>Trámite #{tramite.id} · Placa {plate}</p>
          </div>
          <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <label htmlFor="motivo-no-ejec" style={{ fontWeight: 600, fontSize: '13px' }}>Motivo *</label>
            <select id="motivo-no-ejec" value={motivo} onChange={e => setMotivo(e.target.value)} required
              style={{ padding: '8px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
              <option value="">Seleccione...</option>
              {motivos.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select>
            {selected && (
              <div style={{ fontSize: '12px', padding: '8px 10px', borderRadius: '8px', background: selected.genera_novedad ? '#fef2f2' : '#fffbeb', color: selected.genera_novedad ? '#b91c1c' : '#92400e' }}>
                {selected.genera_novedad
                  ? 'Este motivo genera una novedad: el trámite pasará a Novedades Pendientes hasta que se subsane.'
                  : 'El trámite saldrá de "Listos para Finalizar" hasta que se habilite el reintento.'}
              </div>
            )}
            <label htmlFor="obs-no-ejec" style={{ fontWeight: 600, fontSize: '13px' }}>Observaciones {motivo === 'otro' ? '*' : ''}</label>
            <textarea id="obs-no-ejec" rows={3} value={observaciones} onChange={e => setObservaciones(e.target.value)}
              placeholder="Detalle del intento (opcional)" style={{ padding: '8px', borderRadius: '8px', border: '1px solid #cbd5e1', resize: 'vertical' }} />
          </div>
          <div className="modal-footer" style={{ padding: '12px 20px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <button type="button" onClick={onClose} className="btn-secondary" disabled={saving}>Cancelar</button>
            <button type="submit" disabled={saving}
              style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#d97706', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
              {saving ? '⏳ Guardando...' : 'Registrar intento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoEjecutadoModal;
